import API from './api';

export default class OrderApi {
  static update(id, params) {
    return API.put(`/advertisers/orders/${id}`, params);
  }
}
